import { useEffect, useRef } from "react";

// Lector USB = teclado rápido (Ingreso de inventario, brief 26-oct-2026; la regla de captura.html): una
// ráfaga de 6+ caracteres a menos de 40 ms entre teclas que termina en Enter o Tab. Se reconoce AUNQUE el
// cursor esté en un campo: lo que la ráfaga alcanzó a escribir ahí se devuelve a como estaba (medido el
// 30-sep en captura.html: sin eso, un precio quedaba «47730979099363»). Distinto de `useBarcodeScanner` del
// Mostrador, que se aparta cuando hay un campo con foco: al cargar una repisa siempre hay uno.

export const RAFAGA_MIN = 6;
export const RAFAGA_MS = 40;

type Rafaga = { chars: string; t0: number; tUlt: number; campo: HTMLInputElement | null; antes: string | null };
const vacia = (): Rafaga => ({ chars: "", t0: 0, tUlt: 0, campo: null, antes: null });

// Devuelve un campo controlado por React a un valor: el setter nativo + un evento `input`, que es lo que
// React escucha (asignar `.value` a secas no dispara su onChange).
function devolver(campo: HTMLInputElement, valor: string): void {
  // Reflect.set con el campo como receptor llama al setter nativo de `value` con `this = campo`.
  Reflect.set(HTMLInputElement.prototype, "value", valor, campo);
  campo.dispatchEvent(new Event("input", { bubbles: true }));
}

export function useLectorRafaga(onCodigo: (codigo: string) => void, activo = true): void {
  const cb = useRef(onCodigo);
  cb.current = onCodigo;
  useEffect(() => {
    if (!activo) return;
    let r = vacia();
    const alTeclear = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.altKey || e.metaKey) return;
      const t = performance.now();
      if (e.key === "Enter" || e.key === "Tab") {
        const n = r.chars.length;
        const promedio = n > 1 ? (r.tUlt - r.t0) / (n - 1) : 999;
        if (n >= RAFAGA_MIN && promedio < RAFAGA_MS && t - r.tUlt < 120) {
          e.preventDefault();
          e.stopPropagation();
          const { chars, campo, antes } = r;
          r = vacia();
          if (campo && antes !== null && campo.value !== antes) devolver(campo, antes);
          cb.current(chars);
          return;
        }
        r = vacia();
        return;
      }
      if (e.key.length === 1) {
        if (t - r.tUlt > 60) {
          const a = document.activeElement;
          const esCampo = a instanceof HTMLInputElement && a.type !== "file";
          r = { chars: "", t0: t, tUlt: t, campo: esCampo ? a : null, antes: esCampo ? a.value : null };
        }
        r.chars += e.key;
        r.tUlt = t;
      }
    };
    document.addEventListener("keydown", alTeclear, true);
    return () => document.removeEventListener("keydown", alTeclear, true);
  }, [activo]);
}
